import { configure } from 'vee-validate';
import { addMethod, array, boolean, mixed, object, setLocale, string } from 'yup';
import { fromI18nKey, messages } from '@aml/common/src/locales/yup';
import { isFinnishPhone, isPhone } from './phone';

configure({
  bails: false,
  validateOnModelUpdate: false,
});

setLocale(messages);

addMethod(string, 'phone', function phone() {
  return this.test('phone', (value, ctx) => {
    if (!isPhone(value)) {
      return ctx.createError({
        path: ctx.path,
        message: fromI18nKey('validation.string.phone'),
      });
    }
    return true;
  });
});

addMethod(string, 'finnishPhone', function finnishPhone() {
  return this.phone().test('finnish-phone', (value, ctx) => {
    if (!isFinnishPhone(value)) {
      return ctx.createError({
        path: ctx.path,
        message: fromI18nKey('validation.string.finnishPhone'),
      });
    }
    return true;
  });
});

export type FormItemSchemaOptions = {
  required?: boolean;
  label?: string;
};

export const formItem = (options?: FormItemSchemaOptions) => {
  let item = object({
    value: mixed<string | number>()
      .optional()
      .test('form-item-required', (value, ctx) => {
        if (options?.required && !value) {
          return ctx.createError({
            path: ctx.path,
            message: fromI18nKey('validation.mixed.required'),
          });
        }
        return true;
      })
      .label(options?.label || 'Tämä'),
    text: string().optional(),
  });

  if (options?.required) {
    item = item.required();
  }

  if (options?.label) {
    item = item.label(options.label);
  }

  return item;
};

export const tableSelection = () =>
  object({
    all: boolean().required(),
    selected: array(mixed<string | number>().required()).required(),
  });
